import BankingOperation from '../../Operation'
import { MdPix } from 'react-icons/md'
import { FaRegClipboard, FaBolt, FaChevronRight } from 'react-icons/fa'

import {
  Card,
  CardHeader,
  CardTitle,
  Divider,
  OptionItem,
  OptionIcon,
  OptionTexts,
  OptionLabel,
  OptionDescription
} from '../../styles'

/*
  As formas de pagar por Pix, cada uma levando à sua tela.

  A ordem é a do uso: colar o código de uma cobrança que chegou por e-mail é o caso comum
  de quem está no computador, e digitar a chave vem depois. Nos apps a lista abre com "ler
  QR code", que aqui não existe — a câmera é do celular.
*/
const OPTIONS = [
  {
    value: 'pix_qr_code',
    label: 'Pix copia e cola',
    description: 'Cole o código que você recebeu',
    Icon: FaRegClipboard
  },
  {
    value: 'pix_key',
    label: 'Transferir por Pix',
    description: 'Envie por CPF, CNPJ, e-mail, celular ou chave aleatória',
    Icon: FaBolt
  }
]

export default function BankingPix ({ onOperationNavigate = () => {}, ...props }) {
  return (
    <BankingOperation title='Área Pix' {...props}>
      {() => (
        <Card gap={4}>
          <CardHeader>
            <CardTitle>Como você quer pagar?</CardTitle>
            <MdPix size={17} color='#FF9800'/>
          </CardHeader>
          <Divider/>

          {OPTIONS.map (({ value, label, description, Icon }, index) => (
            <OptionItem
              key={value}
              type='button'
              last={index === OPTIONS.length - 1}
              onClick={() => onOperationNavigate (value)}
            >
              <OptionIcon>
                <Icon size={15} color='#252525'/>
              </OptionIcon>
              <OptionTexts>
                <OptionLabel>{label}</OptionLabel>
                <OptionDescription>{description}</OptionDescription>
              </OptionTexts>
              <FaChevronRight size={13} color='#B0B0B0'/>
            </OptionItem>
          ))}
        </Card>
      )}
    </BankingOperation>
  )
}
